import { api } from "./client";
import type { CurrentUser, Member, WorkspaceRole } from "./types";

// Wraps /api/me + /api/members/*. See internal/api/handlers/members.go.

export function getMe(): Promise<CurrentUser> {
  return api.get<CurrentUser>("/api/me");
}

export function listMembers(): Promise<Member[]> {
  return api.get<Member[]>("/api/members");
}

export function inviteMember(email: string): Promise<Member> {
  return api.post<Member>("/api/members", { email });
}

export function removeMember(id: number): Promise<void> {
  return api.delete<void>(`/api/members/${id}`);
}

export function changeMemberRole(
  id: number,
  role: WorkspaceRole,
): Promise<void> {
  return api.put<void>(`/api/members/${id}/role`, { role });
}
